// The input file for the main application.
// We load here everything that is needed for the panel application

import Rails from "@rails/ujs"
import "@hotwired/turbo-rails"
import * as ActiveStorage from "@rails/activestorage"
import { startErrorReporting } from "./lib/error_reporting"

startErrorReporting()

Rails.start()
ActiveStorage.start()

document.addEventListener("turbo:frame-missing", (event) => {
  event.preventDefault()
  event.detail.visit(event.detail.response)
})

document.addEventListener("turbo:load", () => {
  if (typeof gtag === "function") {
    gtag("event", "page_view", {
      page_path: window.location.pathname,
      page_title: document.title
    })
  }

  if (typeof fbq === "function") {
    fbq("track", "PageView")
  }
})

import "./controllers/panel"
import "./controllers/duels"
